<template>
  <div
    class="flex -translate-y-2 transform flex-col items-center justify-center gap-2"
  >
    <div class="flex flex-col items-center">
      <span
        class="text-ontick-steel-500 text-center text-lg font-semibold dark:font-medium dark:text-gray-300"
      >
        {{ value }} {{ volumeUnit }}
      </span>
      <span
        class="text-center text-xs text-gray-400"
        v-if="type === 'PORTFOLIO'"
      >
        Exposição máxima
      </span>
    </div>
    <div class="flex w-full items-center gap-4">
      <vue-slider
        v-if="!manualInputEnabled"
        class="!w-full"
        :railStyle="{
          backgroundColor: disabled ? '#6c737f' : '#046299',
        }"
        :min="min"
        :max="max"
        :included="true"
        :process="false"
        :marks="marks"
        :tooltip-placement="['bottom']"
        :disabled="disabled"
        tooltip="none"
        hideLabel
        :value="value"
        @change="$emit('input', $event)"
        @drag-end="$emit('statusValidate', false)"
      >
        <template v-slot:tooltip="{ value }">
          <div
            class="bg-ontick-blue-900 -mt-1.5 rounded-full bg-opacity-75 px-6 py-1 text-center text-xs font-semibold text-gray-200"
          >
            {{ value }}
          </div>
        </template>
        <template v-slot:step="{ active, value }">
          <div
            class="-translate-x-1/2 transform pt-3 text-[10px]"
            :class="active ? 'text-ontick-blue-600' : 'dark:text-gray-300'"
          >
            <span>
              {{ value }}
            </span>
          </div>
        </template>
      </vue-slider>
      <input
        v-if="manualInputEnabled"
        type="number"
        class="dark:bg-ontick-carbon-500 border-ontick-steel-300 rounded border-2 bg-gray-100 text-center text-sm shadow dark:border-0"
        :value="value"
        @input="$emit('input', Number($event.target.value))"
      />
      <button
        v-if="showManualInputButton"
        @click="$emit('toggle-manual-input')"
      >
        <i v-html="manualInputEnabled ? $icons.close : $icons.plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: { VueSlider },
  props: {
    manualInputEnabled: {
      type: Boolean,
    },
    showManualInputButton: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    value: {
      type: [String, Number],
    },
    volumeUnit: {
      type: String,
    },
    marks: {
      type: Function,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped></style>
